// extracted by mini-css-extract-plugin
module.exports = {"group":"styles_group__qGvdR","heading":"styles_heading__HA8s1","items":"styles_items__3b5yB","add":"styles_add__A4iV2","types":"styles_types__3_BDE"};